<script setup lang="ts">
const dynamicPages = {
  '404': defineAsyncComponent(() => import('~layers/app/pages/~404.vue')),
  'plp': defineAsyncComponent(() => import('~layers/app/pages/~plp.vue')),
  'pdp': defineAsyncComponent(() => import('~layers/app/pages/~pdp.vue')),
  'cms': defineAsyncComponent(() => import('~layers/app/pages/~cms.vue')),
  'blog-detail': defineAsyncComponent(() => import('~layers/app/pages/~blog-detail.vue')),
  'blog-overview': defineAsyncComponent(() => import('~layers/app/pages/~blog-overview.vue')),
  'customer-service': defineAsyncComponent(() => import('~layers/app/pages/~customer-service.vue')),
}

const typeToPageMapping = {
  'plp': 'plp',
  'plp-theme': 'plp',
  'plp-brand': 'plp',
  'product_list_page': 'plp',
  'plp-landing': 'cms',
  'pdp': 'pdp',
  'cms': 'cms',
  'cms-brand': 'cms',
  'cms-store': 'cms',
  'cms-page': 'cms',
  'blog-detail': 'blog-detail',
  'blog-overview': 'blog-overview',
  'customer-service-page': 'customer-service',
}

const route = useRoute()
const { fetchRoute } = useCustomRouter()
const { fetchRedirect } = useCustomRouterRedirect()

const esUrlPath = computed(() => route.path.replace(/^\/+|\/+$/g, ''))

const metaData = await fetchRoute(route.path)
provide('meta', ref(metaData))

// Resolve page/component to render
const page = computed(() => {
  return typeToPageMapping[metaData?.page_type]
})

// Resolve page/component to render
const pageComponent = computed(() => {
  return dynamicPages?.[page.value] || dynamicPages?.['404']
})

const redirect = ref()

// No meta data, or unknown component, check for redirect
if (!metaData || !page.value) {
  redirect.value = await fetchRedirect(esUrlPath.value)
  // console.log({ redirect })
  if (redirect.value?.relative_url) {
    // console.log(`redirect to: ${redirect?.relative_url}`)
    await navigateTo(redirect.value?.relative_url, {
      redirectCode: redirect.value?.redirectCode || 301,
      external: true,
    })
  }
}

// No redirect, render 404
if (!page.value && !redirect.value) {
  // throw createError({
  //   statusCode: 404,
  //   message: 'Page Not Found',
  //   fatal: true,
  // })

  const event = useRequestEvent()

  if (event) {
    setResponseStatus(event, 404, 'Page Not Found')
  }
}
</script>

<template>
  <component
    :is="pageComponent"
  />
</template>
